import React from 'react';
import SubPage from '../components/SubPage';
import { subPages } from '../subpages';
import ItPosExtras from '../components/ItPosExtras';

export default function ItPosPage() {
  return <SubPage data={subPages['it-pos-systems']} showcase={<ItPosExtras />} />;
}
